import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import CustomerSelectionModal from "./CustomerSelectionModal";
import JobsEnginnerModal from "./JobsEnginnerModal";
import CustomerService from "../../../Customer/Controller/CustomerController";
import CustomerContactService from "../../../Customer/Controller/CustomerContactController";
import CustomerSiteService from "../../../Customer/Controller/CustomerSiteController";
import CallTypeService from "../../../Setup/controller/CallTypeController/CallTypeController";
import ProjectService from "../../../Setup/controller/ProjectController/ProjectController";
import ProjectCategoryService from "../../../Setup/controller/ProjectCategoryController/ProjectCategoryController";
import ProjectMemberService from "../../../Setup/controller/ProjectMemberController/ProjectMemberController";
import IssuePriorityService from "../../../Setup/controller/IssuePriorityController/IssuePriorityController";
import IssueStatusService from "../../../Setup/controller/IssueStatusController/IssueStatusController";
import SupplierService from "../../../Supplier/Controller/SupplierController";
import AgreementService from "../../../Agreement/Controller/AgreementController";
import JobService from "../../Controller/JobController";
import CurrencyService from "../../../Setup/controller/CurrencyController/CurrencyController";
import DiariesModal from "./DiariesPopup";
import CurrencyTextField from "./CurrencyTextField";
//import CurrencyService from "../../../Setup/controller/CurrencyController/";
import { handleChange, handleSubmit } from "../../Controller/CreateJobController";
import { API_URL, API_KEY } from "../../../../config/CurrencyConfig"
import { formatDateWithFns } from '../../../Common/DateInputFormat';
import useDateFormat from '../../../Common/fetchDateFormat';
import Swal from 'sweetalert2';
import HelpSite from "../../../Common/HelpLink";
import ModuleService from "../../../Setup/controller/ModuleController/ModuleController";
import JobCostService from "../../Controller/JobCostController";
import { convertCurrency } from "../../../Purchasing/View/PurchaseOrderForms/CurrencyConverter";
import LeadUserDefineFieldsSection from './JobUserDefineFieldsSection';
import JobUserDefineService from "../../../Jobs/Controller/UserDefineJobController";
import { handleSubmit as handleUserDefineSubmit } from "../../../Jobs/Controller/CreateUserDefineController";
import JasperReportService from '../../../Dashboard/Controller/JasperReportController';
import axiosInstance from '../../../../config/axiosInstance';
import Draggable from 'react-draggable';
import { handleInvoicing } from "../../Controller/CreateJobInvoicController";
import SaleOrderDetailModal from "../../../Invoice/View/InvoiceDetail";
import ReportService from "../../../Setup/controller/ReportController/ReportController";
import TermsConditionService from "../../../Setup/controller/TermsConditionController/TermsConditionController";
import { PDFDocument } from "pdf-lib";
import BASE_URL from "../../../../config/config";
import CompanySetupController from "../../../SuperAdmin/Controller/Client/SACompanyListController";
import { getMergedPDFBlob } from '../../../Common/ReportPDFService';
import SignatureCanvas from "react-signature-canvas";
import CreateCustomerSite from '../../../Customer/View/CustomerForms/CreateCustomerSite';
import SiteSelectionModal from "./SiteSelectionModal";
import SendEmail from "../../../Common/SendEmailAttachment";
import ContactSelectionModal from "./ContactSelection";
const MODULE_IDS = {
    Assets: 3,
    Parts: 4,
    Suppliers: 5,
    Quotations: 6,
    SalesOrders: 7,
    Purchasing: 8,
    Agreements: 9,
    Jobs: 10,
    Contacts: 15,
    Diaries: 11,
    Invoices: 22,
};
function JobDetail({ JobID, onSuccess, ClientCompanyID, engineersData, isLock, IsDiaries, onClose }) {
    const navigate = useNavigate();
    const location = useLocation();
    const [errors, setErrors] = useState({});
    let JobCostID = localStorage.getItem('JobCostID');
    const getCurrentDateTime = () => {
        const now = new Date();
        const date = now.toISOString().split('T')[0]; // Format: YYYY-MM-DD
        const time = now.toTimeString().split(' ')[0]; // Format: HH:MM:SS
        return { date, time };
    };
    const { date, time } = getCurrentDateTime();

    const [CustomerList, setCustomer] = useState([]);
    const [CustomerContactList, setCustomerContact] = useState([]);
    const [CustomerSiteList, setCustomerSite] = useState([]);
    const [showCustomerModal, setShowCustomerModal] = useState(false);
    const [showDiariesModal, setShowDiariesModal] = useState(false);
    const [showEnginnerModal, setshowEnginnerModal] = useState(false);
    const { theme } = useContext(ThemeContext);
    const [ConvRate, setConvRate] = useState('1.00');
    const [CallTypeList, setCallType] = useState([]);
    const [ProjectList, setProject] = useState([]);
    const [ProjectCategoryList, setProjectCategory] = useState([]);
    const [ProjectMemberList, setProjectMember] = useState([]);
    const [IssuePriorityList, setIssuePriority] = useState([]);
    const [IssueStatusList, setIssueStatus] = useState([]);
    const [SupplierList, SetSupplierData] = useState([]);
    const [AgreementList, SetAgreementData] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [jobCost, setJobCost] = useState("0.00");
    const [modalOpen, setModalOpen] = useState(false);
    const HelpLink = localStorage.getItem('HelpLink');
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [currentEngineer, setCurrentEngineer] = useState(null);
    const [defCurreny, setCurrency] = useState(null);
    const [isEmailingModalOpen, setIsEmailingModalOpen] = useState(false);
    const [emailingName, setEmailingName] = useState("");
    //    const currencySymbol = defCurreny && defCurreny[0]?.Symbol || '$'; // Default to $ if no symbol
    // const [currencySymbol, setCurrencySymbol] = useState('');

    const [currencySymbol1, setCurrencySymbol1] = useState('');
    const [currencyValue1, setCurrencyValue1] = useState('');

    const [currencyCostSymbol1, setCostCurrencySymbol1] = useState('');
    const [currencyCostValue1, setCostCurrencyValue1] = useState('');
    const [BaseCurrency, setBaseCurrency] = useState('');
    const [isChanged, setIsChanged] = useState(false);
    let accordTheme = "accordion-header-light";
    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }
    const ProjectID = localStorage.getItem('ProjectID');
    const [currencyList, setCurrencies] = useState([]);
    const activeDateFormat = useDateFormat();
    const [CurrencyType, setCurrencyType] = useState(null);
    const [isClosed, SetIsClosed] = useState("0");
    const [assignedModules, setAssignedModules] = useState(new Set());

    const [showAssetDetailModal, setShowAssetDetailModal] = useState(false);
    const [isModalInvoiceOpen, setIsModalInvoiceOpen] = useState(false);
    const [currentCustomerSite, setCurrentCustomerSite] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [includeTerms, setIncludeTerms] = useState(false);
    const [isSiteModalOpen, setIsSiteModalOpen] = useState(false);
    const [pdfAttachment, setPdfAttachment] = useState(null);
    const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [Email, setEmail] = useState();
    const [isContactModalOpen, setIsContactModalOpen] = useState(false);
    const handleCloseSaleOrderModal = () => {
        setIsModalInvoiceOpen(false);
    };
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };
    const [KeyNameList, setKeyNames] = useState([]);
    const fetchKeyNames = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const KeyNames = await JobUserDefineService.GetJobUserDefine(redirectCallback, JobID, "10");
            setKeyNames(KeyNames || []);

            // Initialize form data with vc_Value if available
            const initialFormData = {};
            KeyNames.forEach(keyItem => {
                if (keyItem.vc_Value) {
                    initialFormData[keyItem.vc_Name] = keyItem.vc_Value;
                }
            });

            // ✅ Merge into existing formData instead of replacing it
            setFormData(prev => ({
                ...prev,
                ...initialFormData
            }));
        } catch (error) {
            console.error('Error fetching Key Names:', error);
        }
    };

    const handleIntegerChange = (e) => {
        const { name, value } = e.target;
        if (/^\d*$/.test(value)) {
            setFormData(prevData => ({ ...prevData, [name]: value }));
        }
    };

    const handleDecimalChange = (e) => {
        const { name, value } = e.target;
        if (/^\d*\.?\d*$/.test(value)) {
            setFormData(prevData => ({ ...prevData, [name]: value }));
        }
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        setFormData(prevData => ({ ...prevData, [name]: files[0] }));
    };
    useEffect(() => {
        fetchKeyNames();
    }, [JobID]);
    useEffect(() => {
        const initializeData = async () => {
            SetIsClosed("0");
            fetchCurrency();
            setTableData([]);
            if (engineersData.length > 0) {
                setTableData(engineersData);
            }
            fetchCustomers();
            fetchIssuePriority();
            fetchIssueStatus();
            fetchCallType();
            fetchProject();
            fetchCustomerCurrency();
            // fetchAgreement();
            fetchAssignedModules();
            fetchSupplier();
            fetchJobCost();
            await fetchDefaultCurrency();
            if (ProjectID > 0) {
                fetchProjectCategory(ProjectID);
                fetchProjectMember(ProjectID);
            } else {
                setProjectCategory([]);
                setProjectMember([]);
            }

            if (JobID > 0) {

                fetchJobDetailDetail();
                fetchJobEngineers();
                fetchKeyNames();
                fetchSignature(JobID);

            } else {
                await resetForm(); // Now safe to reset the form
                if (ClientCompanyID > 0) {
                    await fetchCustomerData(ClientCompanyID);
                }
                await fetchIssuePriority();
                await fetchIssueStatus();

                setTableData([]);

                if (engineersData.length > 0) {
                    setTableData(engineersData);
                }
                if (IsDiaries === "1") {
                    let callDate = date;
                    let callTime = time;


                    if (engineersData.length > 0) {
                        const engineer = engineersData[0];
                        if (engineer && engineer.StartDate) {
                            callDate = engineer.StartDate;
                            callTime = engineer.StartTime;
                        }
                    }

                    const dateCall = callDate; // Format: YYYY-MM-DD
                    const timeCall = callTime; // Format: HH:MM:SS

                    setFormData((prevData) => ({
                        ...prevData,
                        CallTime: timeCall,
                        TimeToCall: dateCall,
                    }));
                }
                await fetchKeyNames();

            }

        };
        initializeData();
    }, [JobID, ProjectID, JobCostID, engineersData]);
    const fetchCustomerCurrency = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const currencyData = await CurrencyService.fetchCustomerCurrency(redirectCallback);
            setCurrencyType(currencyData[0].CurrencyType);


        } catch (error) {
            console.error('Error fetching currencies:', error);
        }
    };
    const fetchSupplier = async () => {
        try {
            const redirectCallback = () => navigate('/');
            const listOfSupplier = await SupplierService.GetAllSuppliers(redirectCallback);

            SetSupplierData(listOfSupplier);
        } catch (error) {
            console.error('Error fetching customers:', error);
        }
    };
    const fetchJobCost = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const JobCostList = await JobCostService.GetAllJobCost(redirectCallback, JobID);
            const totalCost = JobCostList.reduce((sum, job) => sum + (parseFloat(job.mon_OurCost) || 0), 0);
            return totalCost;

        } catch (error) {
            console.error('Error fetching Agreement Notifications:', error);
        }
    };
    const fetchDefaultCurrency = async () => {
        try {
            const redirectCallback = () => navigate('/');
            const listOfCurreny = await CurrencyService.DefaultCurrency(redirectCallback);
            setCurrency(listOfCurreny);
            setCurrencySymbol1(listOfCurreny[0].Symbol);
            setCurrencyValue1("0.00");
            setCostCurrencySymbol1(listOfCurreny[0].Symbol);
            setCostCurrencyValue1("0.00");
            setBaseCurrency(listOfCurreny[0].Symbol);

        } catch (error) {
            console.error('Error fetching customers:', error);
        }
    };
    const fetchAgreement = async (CustomerID) => {
        try {
            const redirectCallback = () => navigate('/');
            const listOfAgreement = await AgreementService.GetAllAgreement(redirectCallback, CustomerID);
            SetAgreementData(listOfAgreement);
        } catch (error) {
            console.error('Error fetching customers:', error);
        }
    };
    const fetchCustomers = async () => {
        try {
            const redirectCallback = () => navigate('/');
            const listOfCustomers = await CustomerService.GetAllCustomers(redirectCallback);
            setCustomer(listOfCustomers);
        } catch (error) {
            console.error('Error fetching customers:', error);
        }
    };

    const fetchCallType = async () => {
        try {
            const redirectCallback = () => navigate('/');
            const list = await CallTypeService.GetCallType(redirectCallback);
            setCallType(list);
        } catch (error) {
            console.error('Error fetching contract frequencies:', error);
        }
    };
    const fetchCurrency = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const currencyData = await CurrencyService.GetAllCurrencies(redirectCallback);
            setCurrencies(currencyData);
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };
    const fetchIssuePriority = async () => {
        try {
            const redirectCallback = () => navigate('/');
            const list = await IssuePriorityService.GetAllIssuePriority(redirectCallback);
            setIssuePriority(list);

            // Set default issue priority where IsDefault is 1
            const defaultPriority = list.find(priority => priority.IsDefault === 1);
            if (defaultPriority) {

                setFormData(prevFormData => ({
                    ...prevFormData,
                    IssuePriorityID: defaultPriority.ID, // Assuming IssuePriorityID is the field name
                }));
            }
        } catch (error) {
            console.error('Error fetching issue priorities:', error);
        }
    };

    const fetchIssueStatus = async () => {
        try {
            const redirectCallback = () => navigate('/');
            const list = await IssueStatusService.GetAllIssueStatus(redirectCallback);
            setIssueStatus(list);

            const defaultStatus = list.find(status => status.IsDefault === 1);
            if (defaultStatus) {

                setFormData(prevFormData => ({
                    ...prevFormData,
                    IssueStatusID: defaultStatus.ID, // Assuming IssueStatusID is the field name
                }));
            }
        } catch (error) {
            console.error('Error fetching issue statuses:', error);
        }
    };

    const fetchProject = async () => {
        try {
            const redirectCallback = () => navigate('/');
            const list = await ProjectService.GetAllProjects(redirectCallback);
            setProject(list);
        } catch (error) {
            console.error('Error fetching discounts:', error);
        }
    };
    const fetchProjectCategory = async () => {
        try {
            setProjectCategory([]);
            const redirectCallback = () => navigate('/');
            const list = await ProjectCategoryService.GetAllProjectCategories(ProjectID, redirectCallback);
            setProjectCategory(list);

            const defaultCategory = list.find(priority => priority.IsDefault === 1);
            if (defaultCategory) {

                setFormData(prevFormData => ({
                    ...prevFormData,
                    ProjectCategoriesID: defaultCategory.ProjectCategoriesID, // Assuming IssuePriorityID is the field name
                }));
            }


        } catch (error) {
            console.error('Error fetching customer contacts:', error);
        }
    };
    const fetchProjectMember = async () => {
        try {
            setProjectMember([]);
            const redirectCallback = () => navigate('/');
            const list = await ProjectMemberService.GetAllProjectMembers(ProjectID, redirectCallback);
            setProjectMember(list);
        } catch (error) {
            console.error('Error fetching customer contacts:', error);
        }
    };
    const fetchCustomerContact = async (BranchID) => {
        try {

            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            setCustomerContact([]);
            const listOfCustomerContacts = await CustomerContactService.GetContactByBranch(redirectCallback, BranchID);
            setCustomerContact(listOfCustomerContacts);
            if (listOfCustomerContacts.length > 0) {
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    FK_ClientContact_ID: listOfCustomerContacts[0].ClientContactID,
                    ContactName: `${listOfCustomerContacts[0].Title || ''} ${listOfCustomerContacts[0].FirstName || ''} ${listOfCustomerContacts[0].SurName || ''}`.trim(),
                }));
            }
        } catch (error) {
            console.error('Error fetching customer contacts:', error);
        }
    };
    const fetchCustomersSites = async (customerID) => {
        try {
            const redirectCallback = () => navigate('/');
            const listOfCustomerSites = await CustomerSiteService.GetAllCustomersSites(redirectCallback, customerID);
            setCustomerSite(listOfCustomerSites);
        } catch (error) {
            console.error('Error fetching customer sites:', error);
        }
    };
    const fetchCurrencyConvRate = async (newCurrencySymbol) => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };

            const rateConv = await convertCurrency(BaseCurrency, newCurrencySymbol, currencyList, "0");
            setConvRate(rateConv);
        } catch (error) {
            console.error('Error fetching Agreement Notifications:', error);
        }
    };


    const fetchJobDetailDetail = async () => {
        try {
            const redirectCallback = () => navigate('/');

            if (JobID > 0) {

                const jobDetail = await JobService.GetJobByID(redirectCallback, JobID);


                SetIsClosed(jobDetail[0].IsCompleted);
                localStorage.setItem("Closed", jobDetail[0].IsCompleted.toString());
                debugger;
                await fetchCustomerData(jobDetail[0].ClientCompanyID, jobDetail[0].FK_ClientBranch_ID);
                fetchAgreement(jobDetail[0].ClientCompanyID);
                await fetchProjectData(jobDetail[0].ProjectID);
                const listOfCurreny = await CurrencyService.DefaultCurrency(redirectCallback);

                setBaseCurrency(listOfCurreny[0].Symbol);
                setCurrencyValue1(jobDetail[0].Estimate);
                const Cost = await fetchJobCost();
                setCostCurrencyValue1(Cost);

                const formattedDetail = {
                    ...jobDetail[0],
                    DateInvoiced: jobDetail[0].DateInvoiced,
                    DateCreated: jobDetail[0].DateCreated,

                    TimeToCall: jobDetail[0].TimeToCall
                        ? new Date(jobDetail[0].TimeToCall).toISOString().split('T')[0]
                        : null,
                    CustomerID: jobDetail[0].ClientCompanyID,
                    AsbestosChecked: jobDetail[0].AsbestosChecked != null
                        ? jobDetail[0].AsbestosChecked.toString()
                        : null,

                    Estimate: jobDetail[0].Estimate,
                    mon_JobCost: Cost

                };


                //setFormData(formattedDetail);
                setFormData(prev => ({
                    ...prev,
                    ...formattedDetail
                }));
                fetchJobEngineers();


            }
        } catch (error) {
            console.error('Error fetching agreement details:', error);
        }
    };
    const fetchJobEngineers = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            setTableData([]);

            const formatDate = (dateString) => {
                if (!dateString) return null;
                const date = new Date(dateString);
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
                const year = date.getFullYear();
                return `${year}/${month}/${day}`;
            };
            if (JobID > 0) {
                const jobEngineers = await JobService.GetJobEnginners(redirectCallback, JobID);

                const selectedPartsData = jobEngineers.map(detail => ({

                    UserID: detail.UserID,
                    EngineerTimeID: detail.EngineerTimeID,
                    DisplayName: detail.DisplayName,
                    DepartBaseDate: formatDate(detail.DepartBaseDate),
                    DepartBaseTime: detail.DepartBaseTime ? detail.DepartBaseTime.slice(0, 5) : "",
                    ReturnBaseDate: formatDate(detail.ReturnBaseDate),
                    ReturnBaseTime: detail.ReturnBaseTime ? detail.ReturnBaseTime.slice(0, 5) : "",
                    HoursTravel: detail.HoursTravel,
                    StartDate: formatDate(detail.StartDate),
                    StartTime: detail.StartTime ? detail.StartTime.slice(0, 5) : "",
                    EndDate: formatDate(detail.EndDate),
                    EndTime: detail.EndTime ? detail.EndTime.slice(0, 5) : "",
                    HoursDate: detail.HoursDate,
                    PayRateID: detail.PayRateID,
                    Other: detail.Other,

                    // Map other fields as needed
                }));

                setTableData(selectedPartsData);
            }
        } catch (error) {
            console.error('Error fetching supplier details:', error);
        }
    };

    const handleFieldChange = async (event) => {
        setIsChanged(true);
        handleChange(event, formData, setFormData);
        const { name, value } = event.target;


        if (name === "FK_ClientBranch_ID") {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const CustomerSite = await CustomerSiteService.GetCustomerSiteByID(redirectCallback, value);

            if (CustomerSite && CustomerSite.length > 0) {
                setFormData(prevFormData => ({
                    ...prevFormData,
                    FK_ClientBranch_ID: value,
                    Address1: CustomerSite[0].BranchAddress,
                }));
            } else {
                console.warn("No customer site found for ID", value);
            }
        }

    };

    const handleFormSubmit = async (event = null) => {

        if (event) event.preventDefault();
        if (JobID > 0 && !isChanged) {
            return;
        }
        try {

            let EstimateBaseToCurrencyRate = "1.00";
            let CostBaseToCurrencyRate = "1.00";
            const redirectUserList = () => {
                navigate('/JobsList?saved=true');
            };
            const redirectCallback = () => navigate('/');
            formData.ProjectID = ProjectID;
            const formDataWithParts = {
                formData: formData,
                tableData: tableData
            };
            formData.ID = formData.IssueID;

            let finalCurrencySymbol = currencySymbol1;
            if (!currencySymbol1 || currencySymbol1 === "undefined") {
                finalCurrencySymbol = BaseCurrency;
            }
            formData.Estimate = currencyValue1;
            const IsCurrencyExist = await CurrencyService.CurrenyBySymbol(redirectCallback, finalCurrencySymbol);
            const BaseCurrenctCode = await CurrencyService.CurrenyBySymbol(redirectCallback, BaseCurrency);
            if (IsCurrencyExist.length === 0) {
                alert("The currency symbol in Estimate does not exist");
                return false;
            }
            //  BaseCurrency

            if (finalCurrencySymbol != BaseCurrency) {
                if (CurrencyType == "Auto") {
                    const currencyCodes = currencyList.map(currency => currency.vc_CurrencyCode).join(',');
                    const apiUrl = `${API_URL}latest?apikey=${API_KEY}&currencies=${currencyCodes}&base_currency=${IsCurrencyExist[0].vc_CurrencyCode}`;
                    const response = await fetch(apiUrl);
                    const responseData = await response.json();
                    if (responseData.data) {
                        const BaseCurrencyCode = BaseCurrenctCode[0].vc_CurrencyCode;
                        const exchangeRates = responseData.data;
                        if (exchangeRates[BaseCurrencyCode]) {
                            const exchangeRate = exchangeRates[BaseCurrencyCode]; // This is the rate for your BaseCurrencyCode
                            formData.Estimate = (formData.Estimate * exchangeRate);
                            EstimateBaseToCurrencyRate = exchangeRate;

                        }
                    }
                }
                else {

                    formData.Estimate = (formData.Estimate * (1 / (IsCurrencyExist[0].dec_CurrencyToBaseRate)));
                    EstimateBaseToCurrencyRate = IsCurrencyExist[0].dec_CurrencyToBaseRate;

                }
            }

            let finalCurrencyCostSymbol = currencyCostSymbol1;
            if (!currencyCostSymbol1 || currencyCostSymbol1 === "undefined") {
                finalCurrencyCostSymbol = BaseCurrency;
            }
            formData.mon_JobCost = await fetchJobCost();
            const IsCurrencyCostExist = await CurrencyService.CurrenyBySymbol(redirectCallback, finalCurrencyCostSymbol);

            if (IsCurrencyCostExist.length === 0) {
                alert("The currency symbol in Cost does not exist");
                return false;
            }
            if (finalCurrencyCostSymbol != BaseCurrency) {
                if (CurrencyType == "Auto") {
                    const currencyCodes = currencyList.map(currency => currency.vc_CurrencyCode).join(',');
                    const apiUrl = `${API_URL}latest?apikey=${API_KEY}&currencies=${currencyCodes}&base_currency=${IsCurrencyCostExist[0].vc_CurrencyCode}`;
                    const response = await fetch(apiUrl);
                    const responseData = await response.json();
                    if (responseData.data) {
                        const BaseCurrencyCode = BaseCurrenctCode[0].vc_CurrencyCode;
                        const exchangeRates = responseData.data;
                        if (exchangeRates[BaseCurrencyCode]) {
                            const exchangeRate = exchangeRates[BaseCurrencyCode]; // This is the rate for your BaseCurrencyCode
                            formData.mon_JobCost = (formData.mon_JobCost * exchangeRate);
                            CostBaseToCurrencyRate = exchangeRate;

                        }
                    }
                }
                else {
                    formData.mon_JobCost = (formData.mon_JobCost * (1 / (IsCurrencyCostExist[0].dec_CurrencyToBaseRate)));
                    CostBaseToCurrencyRate = IsCurrencyCostExist[0].dec_CurrencyToBaseRate;
                }
            }


            formData.Estimate = parseFloat(formData.Estimate).toFixed(2);
            formData.mon_JobCost = parseFloat(formData.mon_JobCost).toFixed(2);
            formData.BaseCurrency = BaseCurrency;
            formData.EstimatedCurrency = finalCurrencySymbol;
            formData.CostCurrency = finalCurrencyCostSymbol;
            formData.EstimateBaseToCurrencyRate = EstimateBaseToCurrencyRate;
            formData.CostBaseToCurrencyRate = CostBaseToCurrencyRate;
            const message = await handleSubmit(event, formDataWithParts, setFormData, setErrors);

            if (message == "Data saved successfully") {
                setIsChanged(false);
                onSuccess();
                resetForm();
                JobID = localStorage.getItem('JobID');
                await handleUserDefineSubmit({
                    JobID: localStorage.getItem('JobID'),
                    fields: KeyNameList.map(key => ({
                        PK_KeyName_ID: key.PK_KeyName_ID,
                        value: formData[key.vc_Name] || ''
                    }))
                });
                localStorage.setItem('HasRecordUpdated', "1");
                let JobCostID = localStorage.getItem('JobCostID');
                JobCostID = JobCostID + 1;
                localStorage.setItem('JobCostID', JobCostID);
                setShowSuccessMessage(true);

                setTableData([]);
                await fetchJobDetailDetail();
                await fetchJobEngineers();
                await fetchKeyNames();
                window.scrollTo({ top: 0, behavior: 'smooth' });
                setTimeout(() => {
                    setShowSuccessMessage(false);
                }, 5000);
                // redirectUserList();
            }
            else {
                setShowErrorMessage(true);
                window.scrollTo({ top: 0, behavior: 'smooth' });
                setTimeout(() => {
                    setShowErrorMessage(false);
                }, 5000);

            }

        } catch (error) {
            console.error('Error submitting form:', error);
            setErrors({ submit: 'An error occurred while submitting the form. Please try again.' });
        }
    };

    const handleCustomerSelect = async (customer) => {


        const newCurrencySymbol = customer.vc_CurrencySymbol;
        setFormData({
            ...formData,
            CustomerID: customer.ClientCompanyID,
            CustomerName: customer.CompanyName,
            AccountRef: customer.AccountRef,
            FK_ClientBranch_ID: customer.ClientBranchID,
            FK_ClientContact_ID: customer.ClientContactID,
            BranchName: customer.BranchName,
            FK_Currency_ID: customer.vc_CurrencySymbol,
            Telephone: customer.Phone1,
            Address1: customer.Address1,
        });
        /*  if (newCurrencySymbol != null && newCurrencySymbol != "" && newCurrencySymbol != "undefined") {
              setCurrencySymbol1(newCurrencySymbol);
              setCostCurrencySymbol1(newCurrencySymbol);
              setBaseCurrency(newCurrencySymbol);
          }
          else {
              const redirectCallback = () => navigate('/');
              const listOfCurreny = await CurrencyService.DefaultCurrency(redirectCallback);
              setCurrencySymbol1(listOfCurreny[0].Symbol);
              setCostCurrencySymbol1(listOfCurreny[0].Symbol);
              setBaseCurrency(listOfCurreny[0].Symbol);
          }*/
        fetchAgreement(customer.ClientCompanyID);
        fetchCustomersSites(customer.ClientCompanyID);
        fetchCustomerContact(customer.ClientBranchID);


        setShowCustomerModal(false);
    };

    const handleRadioChange20 = (event) => {
        const { value } = event.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            AsbestosChecked: value
        }));
    };

    const handleProjectChange = (event) => {
        const { value } = event.target;
        const projectId = event.target.value;
        const selectedCustomer = ProjectList.find(project => project.ID === parseInt(projectId));
        setFormData({
            ...formData,
            ProjectID: value,
            ProjectCategoriesID: 0, // Reset Site
            ProjectMemberID: 0 // Reset Contact
        });
        fetchProjectCategory(value);
        fetchProjectMember(value);
    };
    const handleOpenModal = (event) => {
        setIsChanged(true);
        const { value } = event.target;
        setCurrentEngineer(null);

        const selectedEngineer = ProjectMemberList.find((project) => project.UserID === parseInt(value, 10));
        if (selectedEngineer) {
            setFormData({
                ...formData,
                UserID: selectedEngineer.UserID,
                DisplayName: selectedEngineer.DisplayName
            });
        } else {
            // Handle case when selected engineer is not found
            console.error('Selected engineer not found');
        }
        // Open the modal
        if (value > 0) {
            setModalOpen(true);
        }
    };
    const handleOpenSchedular = () => {
        if (JobID > 0) {
            setShowDiariesModal(true);
        }
        else {
            Swal.fire({
                title: '',
                text: `Please Create a Job first`,
                icon: 'warning'
            });
        }
    };

    const handleUnlockJob = async () => {
        const redirectCallback = () => navigate('/');
        await JobService.SetJobStatus(redirectCallback, JobID);
        await fetchJobDetailDetail();
    };
    const handleCreateTemplate = async () => {
        const redirectCallback = () => navigate('/');
        setIsEmailingModalOpen(true);

    };

    const handleEditClick = (data, index) => {

        setShowSuccessMessage(false);
        setCurrentEngineer(data, index);
        setModalOpen(true);

    };
    const handleCloseModal = () => {
        setModalOpen(false);
    };
    const handleCloseModalDiaries = () => {
        setShowDiariesModal(false);
        fetchJobEngineers();
    };
    const handleCloseSchedular = () => {
        setShowDiariesModal(false);
    };
    const handleEngieenerFormSubmit = async (formData) => {
        setIsChanged(true);
        if (Array.isArray(formData)) {
            // Create a map for quick lookup of existing entries by EngineerTimeID
            const existingEntriesMap = new Map(tableData.map(entry => [entry.EngineerTimeID, entry]));

            // Separate updated and new entries
            const updatedEntries = [];
            const newEntries = [];

            formData.forEach(data => {
                if (data.EngineerTimeID > 0) {
                    // Update existing entry if present
                    if (existingEntriesMap.has(data.EngineerTimeID)) {
                        updatedEntries.push(data);
                    } else {
                        // If an entry has a valid ID but doesn't exist, add it as new
                        newEntries.push(data);
                    }
                } else {
                    // Generate a unique EngineerTimeID for new entries
                    const newID = tableData.length > 0
                        ? Math.max(...tableData.map(row => row.EngineerTimeID)) + 1
                        : 1;
                    data.EngineerTimeID = 0;
                    newEntries.push(data);
                }
            });

            // Combine updated entries with the new ones, ensuring no duplicates
            const finalTableData = [
                ...tableData.filter(entry => !updatedEntries.some(updated => updated.EngineerTimeID === entry.EngineerTimeID)),
                ...updatedEntries,
                ...newEntries
            ];

            setTableData(finalTableData);
            if (JobID > 0) {
                await handleFormSubmit();
            }
        } else {
            console.error('formData is not an array');
        }
    };

    const removeRow = async (index, ID) => {

        const confirmed = window.confirm("Are you sure you want to delete this record?");
        if (confirmed) {
            try {
                if (ID > 0) {
                    const redirectCallback = () => navigate('/');
                    await JobService.DeleteEngineerByID(redirectCallback, ID);
                    let JobCostID = localStorage.getItem('JobCostID');
                    JobCostID = JobCostID + 1;
                    localStorage.setItem('JobCostID', JobCostID);
                }
                const updatedTableData = [...tableData];
                updatedTableData.splice(index, 1);
                setTableData(updatedTableData);

            } catch (error) {
                console.error('Error deleting job:', error);
            }
        }
    };
    const fetchCustomerData = async (customerID, SiteID = 0) => {
        try {
            const redirectCallback = () => navigate('/');
            const customerData = await CustomerService.GetCustomerByID(redirectCallback, customerID);

            setFormData((prevFormData) => ({
                ...prevFormData,
                AccountRef: customerData[0].AccountRef,
                FK_Currency_ID: customerData[0].vc_CurrencySymbol,
                CustomerName: customerData[0].CompanyName,
                Telephone: customerData[0].Telephone,
                Address1: customerData[0].Address1,
            }));
            debugger;
            await fetchCustomersSites(customerID);
            const selectedSiteID = SiteID > 0 ? SiteID : customerData[0].ClientBranchID;
            await fetchCustomerContact(selectedSiteID);

            if (ClientCompanyID > 0) {
                await handleCustomerSelect(customerData[0]);
            }
        } catch (error) {
            console.error('Error fetching customer data:', error);
        }
    };
    const fetchProjectData = async (projectID) => {
        try {
            if (projectID > 0) {
                fetchProjectCategory(projectID);
                fetchProjectMember(projectID);
            }
        } catch (error) {
            console.error('Error fetching customer data:', error);
        }
    };
    const [formData, setFormData] = useState({
        CustomerID: 0,
        IssueID: 0,
        CustomerName: '',
        Telephone: '',
        Address1: '',
        FK_ClientBranch_ID: 0,
        FK_ClientContact_ID: 0,
        IssueTitle: "",
        Estimate: "0.00",
        mon_JobCost: "0.00",
        Invoiced: 0,
        FK_Supplier_ID: 0,
        ProjectID: 0,
        ProjectCategoriesID: 0,
        CallTypeID: 1,
        ReportedBy: "",
        DateInvoiced: null,
        DateCreated: null,
        vc_SupplierInvoiceNo: "",
        FK_Contract_ID: 0,
        AsbestosChecked: "0",
        TimeToCall: date,
        CallTime: time,
        AlertDays: "1",
        AlertTime: "0",
        UserID: "0",
        IssuePriorityID: 0,
        IssueStatusID: 0,
        EndDate: date,
        EndTime: time,
        BranchName: ""

    });
    const resetForm = () => {

        setFormData({
            CustomerID: 0,
            IssueID: 0,
            CustomerName: '',
            FK_ClientBranch_ID: 0,
            FK_ClientContact_ID: 0,
            Telephone: '',
            Address1: '',
            IssueTitle: "",
            Estimate: "0.00",
            mon_JobCost: "0.00",
            Invoiced: 0,
            FK_Supplier_ID: 0,
            ProjectID: 0,
            ProjectCategoriesID: 0,
            CallTypeID: 1,
            ReportedBy: "",
            DateInvoiced: null,
            DateCreated: null,
            vc_SupplierInvoiceNo: "",
            FK_Contract_ID: 0,
            AsbestosChecked: "0",
            TimeToCall: date,
            CallTime: time,
            AlertDays: "1",
            AlertTime: "0",
            UserID: "0",
            AccountRef: "",
            IssuePriorityID: 0,
            IssueStatusID: 0,
            EndDate: date,
            EndTime: time,
            BranchName: ""
        });
    };
    const handleCurrencyChange = ({ symbol, value }) => {
        setCurrencySymbol1(symbol);
        setCurrencyValue1(value);
    };
    const handleCostCurrencyChange = ({ symbol, value }) => {
        setCostCurrencySymbol1(symbol);
        setCostCurrencyValue1(value);
    };
    const CompanyID = localStorage.getItem("CompanyID");
    const fetchAssignedModules = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const modules = await ModuleService.GetRoleModules(redirectCallback, "en", CompanyID);
            const moduleSet = new Set(modules.map(m => m.PK_SearchModule_ID)); // Store assigned module IDs in a Set
            setAssignedModules(moduleSet);
        } catch (error) {
            console.error('Error fetching assigned modules:', error);
        }
    };
    const handleConfirmTemplate = async () => {
        if (!emailingName.trim()) {
            Swal.fire('Warning!', 'Please enter a name.', 'warning');
            return;
        }

        try {
            const redirectCallback = () => navigate('/');
            await JobService.CreateTemplate(redirectCallback, JobID, emailingName);
            Swal.fire('Success!', `Job Template have been saved successfully.`, 'success');

        } catch (error) {
            Swal.fire('Error!', 'Failed to save record.', 'error');
        } finally {
            setIsEmailingModalOpen(false);
            setEmailingName("");
        }
    };
    const [showPdfModal, setShowPdfModal] = useState(false);
    const [imageData, setImageData] = useState(null);
    const [pdfUrl, setPdfUrl] = useState(null);
    const [reportTitle, setReportTitle] = useState('');
    const [reportLink, setReportLink] = useState('');
    const [inputValues, setInputValues] = useState({});
    const [outputData, setOutputData] = useState([]);
    const [error, setError] = useState(null);


    const getMergedPDFBlob = async (includeTerms = true) => {

        try {

            const currentInputValues = {
                ClientID: localStorage.getItem("CompanyID"),
                ID: JobID
            };

            const redirectCallback = () => {
                navigate('/');
            };

            // ================= MAIN REPORT =================

            let reportData = await ReportService.GetCompanyReports(
                redirectCallback,
                "10"
            );

            reportData = reportData.filter(
                x => x.IsDefault.toString() === "1"
            );

            const reportID =
                reportData.length > 0
                    ? reportData[0].ID
                    : 104;

            const JasperReport =
                await JasperReportService.GetJasperReportByID(reportID);

            let url = JasperReport[0].Link;

            setReportLink(url);

            setReportTitle(JasperReport[0].ReportTitle);

            // replace placeholders in main report
            Object.keys(currentInputValues).forEach((key) => {

                const placeholder = new RegExp(`{${key}}`, 'g');

                let value = currentInputValues[key];

                if (key === "ClientID") {

                    value = localStorage.getItem("CompanyID");

                } else if (key === "UserID") {

                    value = localStorage.getItem("UserID");

                }

                if (url.includes(`{${key}}`)) {

                    url = url.replace(placeholder, value);

                }

            });

            const queryObjMain = {
                ...currentInputValues,
                format: 'pdf',
                ReportName: JasperReport[0].ReportName,
                ReportType: JasperReport[0].ReportType,
                name: JasperReport[0].ReportName
            };

            const queryStringMain =
                new URLSearchParams(queryObjMain).toString();

            const responseMain = await axiosInstance.get(
                `/Dashboard/ProxyReport?${queryStringMain}`,
                { responseType: 'blob' }
            );

            const mainPdfBytes =
                await responseMain.data.arrayBuffer();

            // ================= MERGE PDFs =================

            const mergedPdf = await PDFDocument.create();

            const mainPdf =
                await PDFDocument.load(mainPdfBytes);

            const mainPages =
                await mergedPdf.copyPages(
                    mainPdf,
                    mainPdf.getPageIndices()
                );

            mainPages.forEach((page) =>
                mergedPdf.addPage(page)
            );

            // ================= TERMS PDF =================

            if (includeTerms) {

                const companySetup =
                    await CompanySetupController.GetCompanyByID(
                        redirectCallback,
                        localStorage.getItem("CompanyID")
                    );

                const termFile =
                    companySetup?.[0]?.TermFile;

                // Only attach second PDF if file exists
                if (termFile) {

                    const ClientID =
                        localStorage.getItem('CompanyID');

                    const FileUrl =
                        `${BASE_URL}/uploads/${ClientID}/Admin/TermConditions/${termFile}`;

                    const responseSecond =
                        await axiosInstance.get(
                            FileUrl,
                            { responseType: 'blob' }
                        );

                    const secondPdfBytes =
                        await responseSecond.data.arrayBuffer();

                    const secondPdf =
                        await PDFDocument.load(secondPdfBytes);

                    const secondPages =
                        await mergedPdf.copyPages(
                            secondPdf,
                            secondPdf.getPageIndices()
                        );

                    secondPages.forEach((page) =>
                        mergedPdf.addPage(page)
                    );
                }
            }

            const mergedPdfBytes =
                await mergedPdf.save();

            return new Blob(
                [mergedPdfBytes],
                { type: "application/pdf" }
            );

        } catch (err) {

            console.error("Error executing report:", err);

            setError("Failed to execute the report.");

            return null;
        }
    };

    const generatePDF = async (event) => {
        event.stopPropagation();

        try {


            const blob = await getMergedPDFBlob(includeTerms);

            const finalUrl = URL.createObjectURL(blob);

            setPdfUrl(finalUrl);
            setShowPdfModal(true);

            localStorage.setItem('HasRecordUpdated', "1");

        } catch (err) {
            console.error(err);
        }
    };
    const generatePDFForEmail = async (termsFlag) => {
        try {
            setLoading(true);

            const blob = await getMergedPDFBlob(termsFlag);

            const file = new File([blob], 'Invoice.pdf', {
                type: 'application/pdf'
            });

            setPdfAttachment(file);
            setIsEmailModalOpen(true);

        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const handleStart = (e, ui) => {
        e.stopPropagation();
    }

    const handleInvoice = async () => {
        const JobCostList = await JobCostService.GetAllJobCost(redirectCallback, JobID);
        const CostList = JobCostList.filter(cost => cost.Invoiced === "No");

        const totalCost = JobCostList.reduce((sum, job) => sum + (parseFloat(job.mon_Cost) || 0), 0);
        const totalOurCost = JobCostList.reduce((sum, job) => sum + (parseFloat(job.mon_OurCost) || 0), 0);

        const amountToConvert = formData.Estimate === "0"
            ? (totalCost - totalOurCost).toFixed(2)
            : (formData.Estimate - totalCost).toFixed(2);



        if (CostList.length > 0) {
            let message = "Are you sure to create invoice!";
            if (formData.Invoiced) {
                message = "The invoice for the job has already been created. Do you still want to create?";
            }
            Swal.fire({
                title: 'Are you sure?',
                text: message,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes,Create Invoice!'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        const data = {
                            mon_NetTotal: ConvRate * totalCost,
                            FK_Issue_ID: JobID,
                            mon_CostNetTotal: ConvRate * totalOurCost,
                            
                        };

                        const LastInvoiceID = await handleInvoicing(data);

                        localStorage.setItem('InvoiceID', LastInvoiceID);
                        setShowAssetDetailModal(true);

                        setIsModalInvoiceOpen(true);

                        let JobCostID = localStorage.getItem('JobCostID');
                        JobCostID = JobCostID + 1;
                        localStorage.setItem('JobCostID', JobCostID);
                        // redirectUserList();
                    } catch (error) {

                        console.error('Error invoicing job:', error);
                        Swal.fire(
                            'Error!',
                            'There was a problem invoicing the record.',
                            'error'
                        );
                    }
                }
            });
        }
        else {
            Swal.fire({
                title: '',
                text: `The invoice for the job has already been created.`,
                icon: 'warning'
            });
        }
    };
    const [imagePreview, setImagePreview] = useState(null);
    const [isEditingSignature, setIsEditingSignature] = useState(false);
    const [ID, setID] = useState("0");
    const [showSignature, setShowSignature] = useState(false);
    const [showSignatureModal, setShowSignatureModal] = useState(false);
    const fetchSignature = async (JobID) => {
        try {

            const data = await JobService.GetSignature(JobID);
            if (data.length > 0) {

                setImagePreview(data[0].Signature); // should be relative path
                setID(data[0].ID);
                setIsEditingSignature(false); // start in view mode
            } else {
                setIsEditingSignature(true); // allow drawing if no image
            }
        } catch (error) {
            console.error('Error fetching part images:', error);
        }
    };
    const handleCreateCustomerSiteClick = () => {
        if (formData.CustomerID > 0) {
            if (localStorage.getItem('CustomerSiteContact') === null) {
                localStorage.setItem('CustomerSiteContact', "0");
            }
            setCurrentCustomerSite(null);
            setIsModalOpen(true);
        }
        else {
            Swal.fire({
                title: '',
                text: `Please select customer first to add Site`,
                icon: 'warning'
            });
        }
    };
    const handleSuccess = () => {

        fetchCustomersSites(formData.ClientCompanyID); // Refresh the list after submission
        handleCloseSiteModal();   // Close the modal
    };
    const handleSelectSite = async (site) => {

         setIsChanged(true);
        const CustomerSite = await CustomerSiteService.GetCustomerSiteByID(redirectCallback, site.ClientBranchID);

        if (CustomerSite && CustomerSite.length > 0) {
            setFormData(prevFormData => ({
                ...prevFormData,
                FK_ClientBranch_ID: site.ClientBranchID,
                Address1: CustomerSite[0].BranchAddress,

                BranchName: site.BranchName,
            }));

            fetchCustomerContact(site.ClientBranchID);
        } else {
            console.warn("No customer site found for ID", site.ClientBranchID);
        }


        handleCloseSiteSelectionModal();   // Close the modal
    };

    const handleCloseSiteSelectionModal = () => {
        setIsSiteModalOpen(false);
    };

    const handleCloseSiteModal = () => {
        setIsModalOpen(false);
    };
    const handleCloseEmailModal = async () => {
        setIsEmailModalOpen(false);
    };

    const handleSelectContact = async (contact) => {
         setIsChanged(true);
        setFormData(prevFormData => ({
            ...prevFormData,
            FK_ClientContact_ID: contact.ClientContactID,
            ContactName: contact.ContactName,
        }));

        handleCloseContactSelectionModal();   // Close the modal
    };
    const handleCloseContactSelectionModal = () => {
        setIsContactModalOpen(false);
    };
    return (
        <div>
            {showSuccessMessage && (
                <div class="alert alert-success bg-success text-light border-0 alert-dismissible fade show" role="alert">
                    Data saved successfully.
                </div>
            )}
            {showErrorMessage && (
                <div class="alert alert-danger bg-danger text-light border-0 alert-dismissible fade show" role="alert">
                    Validation Error.

                </div>
            )}

            <form onSubmit={handleFormSubmit} style={{
                display: "flex",
                flexDirection: "column",
                maxHeight: "calc(100vh - 335px)",     // IE/Edge
            }}>
                <div
                    style={{
                        //flex: 1,
                        overflowY: "auto",
                        overflowX: "hidden",
                        // scrollbarWidth: "none", // Firefox
                        // msOverflowStyle: "none", // IE/Edge
                    }}
                //className="scrollable-form"
                >
                    <table style={{ width: "100%" }}>
                        <tbody>
                            <tr>
                                <td style={{ width: "12%" }}>
                                    <label htmlFor="CustomerID" style={{ float: "right" }}> Customer <span style={{ "color": "red" }}>*</span></label>
                                </td>
                                <td style={{ width: "38%" }}>
                                    <input type='hidden' name="IssueID" id="IssueID" value={formData.IssueID} />
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="CustomerID"
                                        name="CustomerID"
                                        value={formData.CustomerName}
                                        onClick={() => setShowCustomerModal(true)}
                                        readOnly
                                        disabled={isClosed === '1' || isClosed === 1}

                                    />
                                    {errors.CustomerID && <div style={{ "color": "red", "fontSize": "0.8vw" }}>{errors.CustomerID}</div>}
                                </td>
                                <td style={{ width: "12%" }}>
                                    <label htmlFor="IssueTitle" style={{ float: "right" }}>Job Details <span style={{ "color": "red" }}>*</span></label>
                                </td>
                                <td rowSpan={6} style={{ width: "38%" }}>
                                    <textarea type="text" rows={8} className="form-control" name="IssueTitle" value={formData.IssueTitle} disabled={isClosed === '1' || isClosed === 1} onChange={handleFieldChange} />
                                    {errors.IssueTitle && <div style={{ "color": "red", "fontSize": "0.8vw" }}>{errors.IssueTitle}</div>}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <label htmlFor="vc_SerialNumber" style={{ float: "right" }} > Site <span style={{ "color": "red" }}>*</span></label>
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="FK_ClientBranch_ID"
                                        name="FK_ClientBranch_ID"
                                        value={formData.BranchName}
                                        onClick={() => setIsSiteModalOpen(true)}
                                        readOnly
                                        disabled={isClosed === '1' || isClosed === 1}

                                    />

                                    {errors.FK_ClientBranch_ID && <div style={{ "color": "red", "fontSize": "0.8vw" }}>{errors.FK_ClientBranch_ID}</div>}

                                </td>
                                <td></td>
                                <td></td>

                            </tr>
                            <tr>
                                <td>
                                    <label htmlFor="FK_ClientContact_ID" className="" style={{ float: "right" }}> Contact <span style={{ "color": "red" }}>*</span></label>
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="FK_ClientContact_ID"
                                        name="FK_ClientContact_ID"
                                        value={formData.ContactName}
                                        onClick={() => setIsContactModalOpen(true)}
                                        readOnly
                                        disabled={isClosed === '1' || isClosed === 1}

                                    />
                                    {errors.FK_ClientContact_ID && <div style={{ "color": "red", "fontSize": "0.8vw" }}>{errors.FK_ClientContact_ID}</div>}
                                </td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>
                                    <label htmlFor="AccountRef" style={{ float: "right" }}>Account Ref  &nbsp;&nbsp;</label>
                                </td>
                                <td>
                                    <input type="text" className="form-control" id="AccountRef" name="AccountRef"
                                        value={formData.AccountRef} onChange={(e) => setFormData({ ...formData, AccountRef: e.target.value })}
                                        readOnly
                                    />
                                </td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>
                                    <label htmlFor="AccountRef" style={{ float: "right" }}>Telephone &nbsp;&nbsp;  </label>
                                </td>
                                <td>
                                    <input type="text" className="form-control" id="AccountRef" name="AccountRef"
                                        value={formData.Telephone} onChange={(e) => setFormData({ ...formData, Telephone: e.target.value })}
                                        readOnly
                                    />
                                </td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>
                                    <label htmlFor="AccountRef" style={{ float: "right" }}>Site Address &nbsp;&nbsp;  </label>
                                </td>
                                <td>
                                    <input type="text" className="form-control" id="Address1" name="Address1"
                                        value={formData.Address1} onChange={(e) => setFormData({ ...formData, Address1: e.target.value })}
                                        readOnly
                                    />
                                </td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td colSpan={4}><hr /></td>
                            </tr>
                            <tr>
                                {(assignedModules.has(MODULE_IDS.Suppliers) &&
                                    <>
                                        <td>
                                            <label style={{ float: "right" }} htmlFor="FK_ClientContact_ID" className={` ${!assignedModules.has(MODULE_IDS.Suppliers) ? 'disabled' : ''}`}> Supplier &nbsp;&nbsp; </label>
                                        </td>
                                        <td>
                                            <select name="FK_Supplier_ID" className='form-control' value={formData.FK_Supplier_ID} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1 || !assignedModules.has(MODULE_IDS.Suppliers)}>
                                                <option value="0">Select Supplier</option>
                                                {SupplierList.map((supplier) => (
                                                    <option key={supplier.PK_Supplier_ID} value={supplier.PK_Supplier_ID}>
                                                        {supplier.vc_SupplierName}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.FK_Supplier_ID && <div style={{ "color": "red", "fontsize": "0.8vw" }}>{errors.FK_Supplier_ID}</div>}
                                        </td>
                                    </>
                                )}
                                <td>
                                    <label htmlFor="AccountRef" style={{ "float": "right" }}> Job Type &nbsp;&nbsp;</label>
                                </td>
                                <td>
                                    <select name="CallTypeID" className='form-control' value={formData.CallTypeID} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1}>
                                        <option value="0">Select Job Type</option>
                                        {CallTypeList.map((callType) => (
                                            <option key={callType.CallTypeID} value={callType.CallTypeID}>
                                                {callType.Description}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.CallTypeID && <div style={{ "color": "red", "fontsize": "0.8vw" }}>{errors.CallTypeID}</div>}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <label htmlFor="Estimate" className="" style={{ float: "right" }}>Est. Price &nbsp;&nbsp;</label>
                                </td>
                                <td>
                                    <table style={{ width: "100%" }}>
                                        <tr>
                                            <td style={{ width: "30%" }}>
                                                <CurrencyTextField initialCurrencySymbol={currencySymbol1} initialCurrencyValue={currencyValue1} onCurrencyChange={handleCurrencyChange} currencyList={currencyList} disabled={isClosed === '1' || isClosed === 1} />
                                            </td>
                                            <td style={{ width: "35%" }}><label htmlFor="mon_JobCost" style={{ float: "right" }}>Cost:</label></td>
                                            <td style={{ width: "25%" }}>
                                                <CurrencyTextField initialCurrencySymbol={currencyCostSymbol1} initialCurrencyValue={currencyCostValue1} onCurrencyChange={handleCostCurrencyChange} currencyList={currencyList} disabled={"1" === '1'} />
                                            </td>
                                        </tr>
                                    </table>

                                </td>

                                <td>
                                    <label htmlFor="FK_ClientContact_ID" style={{ float: "right" }}> Category &nbsp;&nbsp;</label>
                                </td>
                                <td>
                                    <select name="ProjectCategoriesID" className='form-control' value={formData.ProjectCategoriesID} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1}>
                                        <option value="0">Select Category</option>
                                        {ProjectCategoryList.map((category) => (
                                            <option key={category.ProjectCategoriesID} value={category.ProjectCategoriesID}>
                                                {category.CategoryName}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.ProjectCategoriesID && <div style={{ "color": "red", "fontsize": "0.8vw" }}>{errors.ProjectCategoriesID}</div>}
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    <label htmlFor="vc_SupplierInvoiceNo" style={{ float: "right" }}>Cust. Order No. &nbsp;&nbsp;</label>
                                </td>
                                <td>
                                    <table style={{ width: "100%" }}>
                                        <tr>
                                            <td style={{ width: "30%" }}>
                                                <input type="text" className="form-control" name="vc_SupplierInvoiceNo" value={formData.vc_SupplierInvoiceNo} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                                                {errors.vc_SupplierInvoiceNo && <div style={{ "color": "red", "fontsize": "0.8vw" }}>{errors.vc_SupplierInvoiceNo}</div>}
                                            </td>
                                            <td style={{ width: "35%" }}><label htmlFor="DateCreated" style={{ float: "right" }} >Created Date &nbsp;&nbsp;</label></td>
                                            <td style={{ width: "35%" }}>

                                                <input type="date" className="form-control" name="DateCreated" value={formData.DateCreated} onChange={handleFieldChange} readOnly="true" />
                                                {errors.DateCreated && <div style={{ "color": "red", "fontsize": "0.8vw" }}>{errors.DateCreated}</div>}
                                            </td>
                                        </tr>
                                    </table>

                                </td>

                                <td>
                                    <label htmlFor="FK_ClientContact_ID" style={{ float: "right" }}> Priority &nbsp;&nbsp;</label>
                                </td>
                                <td>
                                    <table style={{ width: "100%" }}>
                                        <tr>
                                            <td style={{ width: "30%" }}>
                                                <select name="IssuePriorityID" className='form-control' value={formData.IssuePriorityID} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1}>
                                                    <option value="0">Select Priority</option>
                                                    {IssuePriorityList.map((issue) => (
                                                        <option key={issue.ID} value={issue.ID}>
                                                            {issue.PriorityName}
                                                        </option>
                                                    ))}
                                                </select>
                                                {errors.IssuePriorityID && <div style={{ "color": "red", "fontsize": "0.8vw" }}>{errors.IssuePriorityID}</div>}
                                            </td>
                                            <td>
                                                <label htmlFor="AccountRef" style={{ "float": "right" }}> Status &nbsp;&nbsp;</label>
                                            </td>
                                            <td>
                                                <select name="IssueStatusID" className='form-control' value={formData.IssueStatusID} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1}>
                                                    <option value="0">Select Progress</option>
                                                    {IssueStatusList.map((issue) => (
                                                        <option key={issue.ID} value={issue.ID}>
                                                            {issue.StatusName}
                                                        </option>
                                                    ))}
                                                </select>
                                                {errors.IssueStatusID && <div style={{ "color": "red", "fontsize": "0.8vw" }}>{errors.IssueStatusID}</div>}
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <label htmlFor="TimeToCall" style={{ float: "right" }}>Start Date &nbsp;&nbsp;</label>
                                </td>
                                <td>
                                    <table style={{ width: "100%" }}>
                                        <tr>
                                            <td style={{ width: "30%" }}>
                                                <input type="date" className="form-control" name="TimeToCall" value={formData.TimeToCall} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                                                {errors.TimeToCall && <div style={{ "color": "red", "fontsize": "0.8vw" }}>{errors.TimeToCall}</div>}
                                            </td>
                                            <td style={{ width: "35%" }}>
                                                <label htmlFor="TimeToCall" style={{ float: "right" }}>Start Time &nbsp;&nbsp;</label>
                                            </td>
                                            <td colSpan={2} style={{ width: "35%" }}>
                                                <input type="time" className="form-control" name="CallTime" value={formData.CallTime} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                                                {errors.CallTime && <div style={{ "color": "red", "fontsize": "0.8vw" }}>{errors.CallTime}</div>}
                                            </td>
                                        </tr>
                                    </table>

                                </td>
                                {(assignedModules.has(MODULE_IDS.Agreements) &&
                                    <>

                                        <td>
                                            <label htmlFor="DateInvoiced" style={{ float: "right" }} className={`${!assignedModules.has(MODULE_IDS.Agreements) ? 'disabled' : ''}`}> Agreement &nbsp;&nbsp;</label>
                                        </td>

                                        <td>
                                            <select name="FK_Contract_ID" className='form-control' value={formData.FK_Contract_ID} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1 || !assignedModules.has(MODULE_IDS.Agreements)}>
                                                <option value="0">Select Agreement</option>
                                                {AgreementList.map((agg) => (
                                                    <option key={agg.ContractID} value={agg.ContractID}>
                                                        {agg.contractNumber}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.FK_Contract_ID && <div style={{ "color": "red", "fontsize": "0.8vw" }}>{errors.FK_Contract_ID}</div>}
                                        </td>
                                    </>
                                )}
                            </tr>
                            <tr>

                                <td>
                                    <label htmlFor="TimeToCall" style={{ float: "right" }}>End Date &nbsp;&nbsp;</label>
                                </td>
                                <td>
                                    <table style={{ width: "100%" }}>
                                        <tr>
                                            <td style={{ width: "30%" }}>
                                                <input type="date" className="form-control" name="EndDate" value={formData.EndDate} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                                                {errors.EndDate && <div style={{ "color": "red", "fontsize": "0.8vw" }}>{errors.EndDate}</div>}
                                            </td>
                                            <td style={{ width: "35%" }}>
                                                <label htmlFor="EndTime" style={{ float: "right" }}>End Time &nbsp;&nbsp;</label>
                                            </td>
                                            <td colSpan={2} style={{ width: "35%" }}>
                                                <input type="time" className="form-control" name="EndTime" value={formData.EndTime} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                                                {errors.EndTime && <div style={{ "color": "red", "fontsize": "0.8vw" }}>{errors.EndTime}</div>}
                                            </td>
                                        </tr>
                                    </table>

                                </td>



                                <td>
                                    <label htmlFor="DateInvoiced" style={{ float: "right" }}> Invoiced &nbsp;&nbsp;</label>
                                </td>
                                <td>
                                    <table style={{ width: "100%" }}>
                                        <tr>
                                            <td style={{ width: "10%" }}>
                                                {formData.Invoiced ? (
                                                    <label className="form-control" readOnly="true">Yes</label>
                                                ) : (
                                                    <label className="form-control" readOnly="true">No</label>
                                                )}
                                            </td>
                                            <td style={{ width: "20%" }}>
                                                <label htmlFor="AccountRef" style={{ float: "right" }}> Invoice No&nbsp;&nbsp;</label>
                                            </td>
                                            <td style={{ width: "20%" }}>
                                                <label className="form-control" readOnly="true">{formData.InvoiceNo}</label>
                                            </td>

                                        </tr>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <label htmlFor="ReportedBy" style={{ float: "right" }}>Assisted By &nbsp;&nbsp;</label>
                                </td>
                                <td>
                                    <table style={{ width: "100%" }}>
                                        <tr>
                                            <td style={{ width: "30%" }}>
                                                <input type="text" className="form-control" name="ReportedBy" value={formData.ReportedBy} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                                                {errors.ReportedBy && <div style={{ "color": "red", "fontsize": "0.8vw" }}>{errors.ReportedBy}</div>}
                                            </td>

                                            <td style={{ width: "35%" }}>
                                                <label htmlFor="AsbestosChecked" style={{ float: "right" }}>Job Sheet Received &nbsp;&nbsp;</label>
                                            </td>
                                            <td style={{ width: "35%" }}>
                                                <table style={{ width: "100%" }}>
                                                    <tr>
                                                        <td>
                                                            <input style={{ position: "relative" }} className="form-check-input" type="radio" name="AsbestosChecked" value="0" checked={formData.AsbestosChecked === '0'}
                                                                onChange={handleRadioChange20} disabled={isClosed === '1' || isClosed === 1}
                                                            />
                                                            <label className="col-form-label">No</label>
                                                        </td>

                                                        <td>
                                                            <input style={{ position: "relative" }} className="form-check-input" type="radio" name="AsbestosChecked" value="1" checked={formData.AsbestosChecked === '1'}
                                                                onChange={handleRadioChange20} disabled={isClosed === '1' || isClosed === 1}
                                                            />
                                                            <label className="col-form-label">Yes</label>
                                                        </td>

                                                    </tr>
                                                </table>
                                            </td>
                                        </tr>
                                    </table>

                                </td>

                                <td>
                                    <label htmlFor="DateInvoiced" style={{ float: "right" }}> Invoice Date &nbsp;&nbsp;</label>
                                </td>
                                <td>

                                    <table style={{ width: "100%" }}>
                                        <tr>

                                            <td>
                                                <input type="date" className="form-control" name="DateInvoiced" value={formData.DateInvoiced} onChange={handleFieldChange} readOnly="true" />
                                            </td>
                                            <td>
                                                {!isEditingSignature && imagePreview && (
                                                    <label htmlFor="DateInvoiced" style={{ float: "right" }}> Signature &nbsp;&nbsp;</label>
                                                )}
                                            </td>
                                            <td>
                                                {!isEditingSignature && imagePreview && (
                                                    <a
                                                        href="#"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            setShowSignatureModal(true);
                                                        }}
                                                    >
                                                        View Signature
                                                    </a>
                                                )}
                                            </td>


                                        </tr>
                                    </table>



                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <label htmlFor="TimeToCall" style={{ float: "right" }}>No action alert  &nbsp;&nbsp;</label>
                                </td>
                                <td>
                                    <table style={{ width: "100%" }}>
                                        <tr>
                                            <td style={{ width: "30%" }}>
                                                <input type="text" className="form-control" name="AlertDays" value={formData.AlertDays} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                                            </td>
                                            <td style={{ width: "70%" }}>
                                                <select name="AlertTime" className='form-control' value={formData.AlertTime} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1}>
                                                    <option value="0">No Alert</option>
                                                    <option value="1">Hour(s)</option>
                                                    <option value="24">Day(s)</option>
                                                    <option value="168">Week(s)</option>
                                                    <option value="720">Month(s)</option>
                                                </select>
                                                {errors.AlertTime && <div style={{ "color": "red", "fontsize": "0.8vw" }}>{errors.AlertTime}</div>}
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                            {KeyNameList.length > 0 && (
                                <>
                                    <LeadUserDefineFieldsSection
                                        KeyNameList={KeyNameList}
                                        formData={formData}
                                        errors={errors}
                                        handleInputChange={handleFieldChange}
                                        handleDecimalChange={handleDecimalChange}
                                        handleIntegerChange={handleIntegerChange}
                                        handleFileChange={handleFileChange}
                                    />
                                </>
                            )}
                            <tr>
                                <td>
                                    <label htmlFor="Engineers" style={{ float: "right" }}>Engineers &nbsp;&nbsp;</label>
                                </td>
                                <td>
                                    <table style={{ width: "100%" }}>
                                        <tr>
                                            <td>
                                                <select name="UserID" className='form-control' value={formData.UserID} onChange={handleOpenModal} disabled={isClosed === '1' || isClosed === 1}>
                                                    <option value="0">Select Engineers</option>
                                                    {ProjectMemberList.map((project) => (
                                                        <option key={project.UserID} value={project.UserID}>
                                                            {project.DisplayName}
                                                        </option>
                                                    ))}
                                                </select>
                                                {errors.UserID && <div style={{ "color": "red", "fontsize": "0.8vw" }}>{errors.UserID}</div>}
                                            </td>
                                            {(assignedModules.has(MODULE_IDS.Diaries) &&
                                                <td>
                                                    <button style={{ background: "#28a745" }} type="button" className={`btn btn-secondary btn-sm ${parseInt(isLock) > 0 ? 'disabled' : ''}`} onClick={handleOpenSchedular} disabled={isClosed === '1' || isClosed === 1 || parseInt(isLock) > 0}>
                                                        <img src="assets/img/resources/schedule.png" alt="Add icon" style={{ height: "10px" }} />   Scheduler
                                                    </button>
                                                </td>
                                            )}

                                        </tr>
                                    </table>
                                </td>
                            </tr>

                        </tbody>
                    </table>


                    <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                        <div class='col-sm-12'>


                            <table className="table m-0 table-hover">
                                <thead>
                                    <tr>
                                        <th style={{ "width": "10%" }} >Engineer</th>
                                        <th style={{ "width": "15%" }}>Begin Travel</th>
                                        <th style={{ "width": "15%" }}>End Travel</th>
                                        <th style={{ "width": "10%" }}>Travel</th>
                                        <th style={{ "width": "15%" }}>Start Job</th>
                                        <th style={{ "width": "15%" }}>Finish Date</th>
                                        <th style={{ "width": "5%" }}>Hours</th>
                                        <th style={{ "width": "5%" }}>Rate</th>
                                        <th style={{ "width": "5%" }}>Other</th>
                                        <th style={{ "textAlign": "right", "width": "5%" }}>Action</th> {/* Add this for the remove button */}
                                    </tr>
                                </thead>
                            </table>
                        </div>
                    </div>
                    <div className="row mb-3" style={{ "overflow-y": "auto", "maxHeight": "80px", marginLeft: "-5px" }}>
                        <div class='col-sm-12'>
                            <table className="table m-0 table-hover">
                                <tbody>
                                    {tableData.map((data, index) => (
                                        <tr key={data.EngineerTimeID}
                                            onClick={data.EngineerTimeID > 0 && (isClosed === '0' || isClosed === 0) ? () => handleEditClick(data, index) : undefined}
                                            style={{ cursor: data.EngineerTimeID > 0 && (isClosed === '0' || isClosed === 0) ? 'pointer' : 'default' }}>

                                            <td style={{ "width": "10%" }} className="no-wrap">{data.DisplayName}</td>
                                            <td style={{ "width": "15%" }} className="no-wrap">{data?.ReturnBaseDate ? formatDateWithFns(data.DepartBaseDate, activeDateFormat) : null} {data.DepartBaseTime}</td>
                                            <td style={{ "width": "15%" }} className="no-wrap">{data?.ReturnBaseDate ? formatDateWithFns(data.ReturnBaseDate, activeDateFormat) : null} {data.ReturnBaseTime}</td>
                                            <td style={{ "width": "10%" }} className="no-wrap">{data.HoursTravel}</td>
                                            <td style={{ "width": "15%" }} className="no-wrap">{formatDateWithFns(data.StartDate, activeDateFormat)} {data.StartTime}</td>
                                            <td style={{ "width": "15%" }} className="no-wrap">{formatDateWithFns(data.EndDate, activeDateFormat)} {data.EndTime}</td>
                                            <td style={{ "width": "5%" }} className="no-wrap">{data.HoursDate}</td>
                                            <td style={{ "width": "5%" }} className="no-wrap">{data.PayRateID}</td>
                                            <td style={{ "width": "5%" }} className="no-wrap">{data.Other ? 'Yes' : 'No'}</td>
                                            <td style={{ "textAlign": "right", "width": "5%" }}>

                                                <button type='button' style={{ "background": "none", "border": "none" }} className={`text-danger ${parseInt(isLock) > 0 ? 'disabled' : ''}`} disabled={isClosed === '1' || isClosed === 1 || isLock > 0} onClick={(e) => {
                                                    e.stopPropagation(); // Prevents triggering the row click
                                                    removeRow(index, data.EngineerTimeID);
                                                }}>
                                                    <i className="icofont-ui-delete" aria-hidden="true"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="row" style={{
                        position: "sticky",
                        bottom: "0",
                        background: "white",
                        padding: "2px",
                        zIndex: "1000",
                        // justifyContent: "flex-end",
                        borderTop: "1px solid #ccc",

                    }}>
                        <div className="col-sm-3">
                            {(assignedModules.has(MODULE_IDS.Invoices) &&
                                <button className='btn btn-secondary btn-sm' style={{ "marginLeft": "10px", textAlign: "left", background: "#2E7D32" }} onClick={handleInvoice} disabled={isClosed === '1' || isClosed === 1 || localStorage.getItem('LicenseExpired') == "1"}>
                                    <i className="icofont-file-alt" aria-hidden="true"> Invoice</i>
                                </button>
                            )}
                        </div>
                        <div className="col-sm-9">
                            {(isClosed === '1' || isClosed === 1 &&
                                < button type="button" className={`btn btn-secondary ${parseInt(isLock) > 0 || localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} onClick={handleUnlockJob} disabled={parseInt(isLock > 0)}>
                                    <img src="assets/img/resources/re-open-job.png" alt="Add icon" style={{ height: "10px" }} />
                                    Reopen

                                </button>
                            )}
                            <button onClick={() => onClose(isChanged)} type="button" className={`btn btn-danger`} style={{ float: "right", "marginLeft": "5px" }}>
                                <img src="assets/img/resources/close-button-icon.png" alt="Add icon" style={{ height: "10px" }} /> Close
                            </button>
                            <button type="submit" className={`btn btn-primary ${parseInt(isLock) > 0 || localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} style={{ float: "right", "marginLeft": "5px" }} disabled={isClosed === '1' || isClosed === 1 || parseInt(isLock > 0)}>
                                <img src="assets/img/resources/update-icon.png" alt="Add icon" style={{ height: "10px" }} />
                                {JobID > 0 ? ' Update' : ' Save'}

                            </button>
                            <button style={{ "marginLeft": "5px", float: "right" }} type="button" className="btn btn-email" onClick={() => generatePDFForEmail(includeTerms)}>
                                <i className="icofont-email" aria-hidden="true"></i> Email
                            </button>
                            <button type="button" className={`btn btn-secondary`} style={{ float: "right", "marginLeft": "5px" }} onClick={generatePDF} >
                                <img src="assets/img/resources/printer-icon.png" alt="Add icon" style={{ height: "10px" }} />  Print
                            </button>
                            <button type="button" className={`btn btn-warning ${parseInt(isLock) > 0 || localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} style={{ float: "right", "marginLeft": "5px" }} onClick={handleCreateTemplate} >
                                <img src="assets/img/resources/template-button-icon.png" alt="Add icon" style={{ height: "10px" }} />  Template
                            </button>



                        </div>
                    </div>
                </div>
            </form >
            <CustomerSelectionModal
                show={showCustomerModal}
                onClose={() => setShowCustomerModal(false)}
                customers={CustomerList}
                onSelectCustomer={handleCustomerSelect}
                refreshCustomers={CustomerList}
            />

            <JobsEnginnerModal
                show={modalOpen}
                onClose={handleCloseModal}
                onFormSubmit={handleEngieenerFormSubmit}
                ProjectMemberList={ProjectMemberList}
                data={formData}
                EngineerData={currentEngineer}

            />
            {
                showDiariesModal && (
                    <DiariesModal
                        show={showDiariesModal}
                        onClose={handleCloseModalDiaries}
                        UserID={formData.UserID}
                        JobID={JobID}
                        ProjectMemberList={ProjectMemberList}
                    />
                )
            }
            {isEmailingModalOpen && (
                <div className="modal show fade" style={{ display: "block", background: "rgba(0,0,0,0.5)" }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Add Template</h5>
                                <button type="button" className="btn-close" onClick={() => setIsEmailingModalOpen(false)}></button>
                            </div>
                            <div className="modal-body">
                                <div className="row mb-3" style={{ "marginLeft": "0px", "marginRight": "0px", "marginTop": "10px" }}>

                                    <div className="col-sm-12">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter Name"
                                            value={emailingName}
                                            onChange={(e) => setEmailingName(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-secondary" onClick={() => setIsEmailingModalOpen(false)}>Cancel</button>
                                <button className="btn btn-primary" onClick={handleConfirmTemplate}>Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {showPdfModal && pdfUrl && (
                <div className="modal fade show d-block" tabIndex="-1">
                    <div className="modal-dialog modal-lg">
                        <Draggable handle=".modal-content" onStart={handleStart}>
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">PDF Report</h5>
                                    <button type="button" className="close" onClick={() => setShowPdfModal(false)}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <embed src={pdfUrl} type="application/pdf" width="100%" height="600px" />
                                </div>
                            </div>
                        </Draggable>
                    </div>

                </div>
            )}
            {isModalInvoiceOpen && (
                <SaleOrderDetailModal InvoiceID={localStorage.getItem('InvoiceID')} onClose={handleCloseSaleOrderModal} />
            )}
            {showSignatureModal && (
                <div
                    className="modal fade show"
                    style={{
                        display: "block",
                        backgroundColor: "rgba(0,0,0,0.5)"
                    }}
                >
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">

                            <div className="modal-header">
                                <h5 className="modal-title">Signature</h5>

                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setShowSignatureModal(false)}
                                ></button>
                            </div>

                            <div className="modal-body text-center">
                                <img
                                    src={`${BASE_URL}/${imagePreview}`}
                                    alt="Signature"
                                    style={{
                                        maxWidth: "100%",
                                        maxHeight: "500px",
                                        border: "1px solid #ddd"
                                    }}
                                />
                            </div>

                            <div className="modal-footer">
                                <button
                                    className="btn btn-secondary"
                                    onClick={() => setShowSignatureModal(false)}
                                >
                                    Close
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            )}
            {isModalOpen && (
                <CreateCustomerSite
                    site={currentCustomerSite}
                    onClose={handleCloseModal}
                    onSuccess={handleSuccess}
                    CustomerID={formData.ClientCompanyID}
                />
            )}
            {isSiteModalOpen && (
                <SiteSelectionModal
                    show={isSiteModalOpen}
                    onClose={handleCloseSiteSelectionModal}
                    onSelectSite={handleSelectSite}
                    ClientCompanyID={formData.CustomerID}
                />
            )}
            {isEmailModalOpen && (
                <SendEmail
                    onClose={handleCloseEmailModal}
                    ToEmail={Email}
                    pdfAttachment={pdfAttachment}
                    setPdfAttachment={setPdfAttachment}   // ✅ ADD THIS
                    getMergedPDFBlob={getMergedPDFBlob}   // ✅ ADD THIS
                    ReportName="Job.pdf"
                />
            )}
            {isContactModalOpen && (
                <ContactSelectionModal
                    show={isContactModalOpen}
                    onClose={handleCloseContactSelectionModal}
                    onSelectContact={handleSelectContact}
                    ClientBranchID={formData.FK_ClientBranch_ID}
                />
            )}
        </div>
    );
}

export default JobDetail;
